import { Model as o } from "../../../../model.js";
class r extends o {
  constructor(e) {
    super(), this.type = e.type, this.now = e.now, this.readyAt = e.readyAt, this.channel = e.channel, this.numberPeople = e.numberPeople;
  }
}
export {
  r as ShopSessionServiceModel
};
//# sourceMappingURL=service.model.js.map
